import { Skeleton } from '@/common/components/ui/skeleton';
import { DeviceGridSkeleton } from '@/features/telemetry/components/device-grid-skeleton/DeviceGridSkeleton';

export const OverviewPageSkeleton = () => {
  return (
    <div className="space-y-5 pb-10">
      <div className="flex flex-col gap-1">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-5 w-72" />
      </div>
      <Skeleton className="h-11 w-full rounded-lg" />
      <div className="flex items-center justify-between gap-3">
        <Skeleton className="h-4 w-56" />
        <Skeleton className="h-9 w-64 rounded-md" />
      </div>
      <DeviceGridSkeleton />
    </div>
  );
};
